import { render, staticRenderFns } from "./RecycleTypeChartLegend.vue?vue&type=template&id=f344a8b8&scoped=true"
import script from "./RecycleTypeChartLegend.vue?vue&type=script&lang=js"
export * from "./RecycleTypeChartLegend.vue?vue&type=script&lang=js"
import style0 from "./RecycleTypeChartLegend.vue?vue&type=style&index=0&id=f344a8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f344a8b8",
  null
  
)

export default component.exports